import nextI18NextConfig from './next-i18next.base.config';

module.exports = {
  ...nextI18NextConfig,
};
